<template>
    <div class="main">

        <div class="banner">
            <div class="banner-left">
                <div class="title">{{ $t("develop.theme") }}<br>{{ $t("develop.title") }}</div>

                <div style="margin-top: 55px; margin-right: 115px;">
                    <div class="content">{{ $t("develop.advantage") }}<br>{{ $t("develop.advantage2") }}</div>
                    <!-- <div class="content">BIT Network凭借精准定位、团队实力</div>
                    <div class="content">和先发优势以及全球化的潜力</div>
                    <div class="content">在RWA赛道中占据领先地位</div> -->
                </div>

            </div>

            <div class="banner-right">
                <img :src="require('../assets/develop/dev-logo.png')" alt="" />
            </div>
        </div>

        <Board></Board>


        <div class="develop-container">
           
            <div class="module-section">
                <div class="module-content">
                    <div class="module-left">
                        <div class="module-title">{{ $t("develop.github.title") }}</div>
                        <div class="module-describe">{{ $t("develop.github.describe") }}</div>
                         <div class="module-describe">{{ $t("develop.github.describe2") }}</div>
                          <div class="module-describe">{{ $t("develop.github.describe3") }}</div>
                           <div class="module-describe2">{{ $t("develop.github.describe4") }}</div>
                           <div class="module-describe">
                            ·{{ $t("develop.github.advantage") }}<br> 
                            ·{{ $t("develop.github.advantage2") }}<br> 
                            ·{{ $t("develop.github.advantage3") }} 
                        </div>
                        <a
                            href="https://github.com/BIT-Networkbc"
                            target="_blank"
                            class="module-button"
                            @click.stop
                        >
                            {{ $t("develop.github.btn") }}
                        </a>
                    </div>
                    <div class="module-right">
                        <img src="../assets/develop/Github.png" alt="" />
                    </div>
                </div>
            </div>
        

            <div class="module-section">
                <div class="module-content">
                    <div class="module-left">
                        <div class="module-title">{{ $t("develop.redbook.title") }}</div>
                        <div class="module-describe">{{ $t("develop.redbook.describe") }}</div>
                        <div class="module-describe">{{ $t("develop.redbook.describe2") }}</div>
                        <div class="module-button" @click="openRedBook">
                            {{ $t("develop.redbook.btn") }}
                        </div>
                    </div>
                    <div class="module-right">
                        <img src="../assets/develop/redbookpicture.png" alt="" @click="openRedBook" />
                    </div>
                </div>
            </div>


            <div class="module-section">
                <div class="module-content">
                    <div class="module-left">
                        <div class="module-title">{{ $t("develop.sdk.title") }}</div>
                        <div class="module-describe">{{ $t("develop.sdk.describe") }}</div>
                        <div class="module-describe">{{ $t("develop.sdk.describe2") }}</div>
                        <div class="module-button" @click="openWhiteBook">
                            {{ $t("develop.sdk.btn") }}
                        </div>
                    </div>
                    <div class="module-right">
                        <img src="../assets/develop/whitebookpicture.png" alt="" @click="openWhiteBook" />
                    </div>
                </div>
            </div>
            
        </div>


        <!-- 使用同一个RedBook组件，根据状态动态切换显示内容 -->
        <RedBook :show="showRedBook || showWhiteBook" @showReceive="showReceive" :bookType="currentBookType"></RedBook>
    </div>
</template>

<script>
import RedBook from "../components/RedBook.vue";
import Board from '@/components/Board.vue'
export default {
    name: "Develop",
    components: { Board, RedBook },
    data() {
        return {
            showRedBook: false,
            showWhiteBook: false,
            currentBookType: 'red' // 'red' 或 'white'
        };
    },
    methods: {
        showReceive(data) {
            // 根据当前显示的书籍类型关闭对应的窗口
            if (this.currentBookType === 'red') {
                this.showRedBook = data;
            } else {
                this.showWhiteBook = data;
            }
        },
        openRedBook() {
            this.currentBookType = 'red';
            this.showRedBook = true;
        },
        openWhiteBook() {
            this.currentBookType = 'white';
            this.showWhiteBook = true;
        }
    },
};
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    margin-top: 50px;

    .banner {
        /* 固定画布宽度与居中 */
        width: 100%;
        
        
        margin: 0 auto;

        /* 固定高度（30vw ≈ 576px） */
        height: 576px;
        position: relative;
        background-image: url("../assets/home/RWAbackground.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
       

        /* 新增：弹性居中布局 */
        display: flex;
        justify-content: center;
        align-items: center;
       
        box-sizing: border-box;

        /* 移除会导致位置随视口变化的规则 */
        /* height: 30vw; */
        /* width: 100vw; */
        /* margin-left: calc(-50vw + 50%); */

        .banner-left {
            flex: 1 1 auto;
            max-width: 1000px;
            text-align: left;
            z-index: 2;
            position: relative;
            left: 170px;
            /* 标题样式 */
            .title {
                color: #ffffff;
                font-size: 70px;
                font-weight: 700;
                line-height: 1.6;
                margin-bottom: 10px;
                font-family: 'Arial', sans-serif;
                max-width: 1600px;
            }
           
            /* 内容文本样式 */
            .content {
                font-family: 'Arial', sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #aaa9a9a2;
                max-width: 100%;
                line-height: 1.4;
            }
        }

        /* 横幅右侧图片区域 */
        .banner-right {
            top:10px;
            left:-100px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10;
            position: relative;
            
            img {
                width: 100%;
                height: auto;
                scale: 0.9;
                
            }
        }
    }


    .develop-container {
       
        position: relative;
        margin: 0 auto;
        width: 100%;
        padding-top: 80px;
        
 background-image: url('../assets/background/background2.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
        .module-section {
        padding-bottom: 80px;
        
      
        position: relative;
        
        width: 100%;
        margin: 0 auto;
            .module-content {
                display: flex;
                align-items: center;
                gap: 110px;





                .module-left {
                    flex: 1;

                    .module-title {
                        font-family: '微软雅黑';
                        font-size: 44px;
                        font-weight: 530;
                        color: #ffffff;
                        margin-bottom: 50px;
                        line-height: 1.2;
                        letter-spacing: 2px; 
                    }

                    .module-describe {
                        width: 620px;
                        font-size: 20px;
                        color: #979595e3;
                        ;
                        line-height: 1.2;
                        margin-bottom: 20px;
                    }

                    .module-describe2 {
                        font-size: 20px;
                        color: #a5a1a1;
                        line-height: 1.8;
                        
                    }

                    .module-button {

                        display: inline-block;
                        font-family: '微软雅黑';
                        background: linear-gradient(135deg, #ff3b30, #c91e2b);
                        color: #ffffff;
                        padding: 11px 30px;
                        border-radius: 23px;
                        font-size: 22px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        border: none;
                        outline: none;
                        text-decoration: none;
                    }


                }
            }

            .module-right {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    max-width: 100%;
                    height: auto;
                    border-radius: 12px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
                    cursor: pointer;
                    transition: transform 0.3s ease;


                }
            }
        }
    }
}
</style>

<style lang="scss" scoped>
/* 让页面主体容器居中并具有响应式左右留白 */
.develop-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center; /* 子元素水平居中 */
  padding: 0 clamp(12px, 4vw, 32px);
  box-sizing: border-box;
}

/* 每个模块占满行，但内部内容居中 */
.module-section {
  width: 100%;
}

/* 模块内容居中显示，限制最大宽度 */
.module-content {
  width: 100%;
  max-width: 1200px;        /* 你可以根据设计改为 1100/1280 等 */
  margin: 0 auto;           /* 居中关键 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(12px, 3vw, 32px);
}

/* 两列均衡分配空间 */
.module-left,
.module-right {
  flex: 1 1 0;
}

/* 图片在容器内自适应 */
.module-right img {
  max-width: 100%;
  height: auto;
  display: block;
}
</style>